import { render, staticRenderFns } from "./QualityRating.vue?vue&type=template&id=d87f03dc&lang=pug"
import script from "./QualityRating.vue?vue&type=script&lang=js"
export * from "./QualityRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports